export const Footer = () => {
  const date = new Date();
  return (
    <div style={{ textAlign: 'center', marginTop: '10rem' }}>
      <img src="/a_logo_transparent_black.png" alt="A logo" width={100} />
      <p style={{ fontSize: 12 }}>© Allochiria {date.getFullYear()} </p>
    </div>
  );
};
